<template>
  <div>
    <div :style="styleSize" class="card" :class="flip">
      <div class="card-flipper">
        <div :style="styleBackground" class="front"></div>
        <div :style="styleImage" class="back"></div>
      </div>
    </div>
  </div>
</template>

<script>
import randomColor from 'randomcolor'

export default {
  name: 'image-loader',
  props: {
    url: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    hue: String
  },
  data () {
    return {
      loadedUrl: '',
      image: new Image()
    }
  },
  computed: {
    flip () {
      return {
        flip: this.loadedUrl !== ''
      }
    },
    styleSize () {
      return {
        'width': `${this.width}px`,
        'height': `${this.height}px`
      }
    },
    styleBackground () {
      const style = Object.assign({}, this.styleSize)
      let selectedHue = 'red'
      if (this.hue !== '') selectedHue = this.hue
      style['background-color'] = randomColor({
        hue: selectedHue,
        luminosity: 'light'
      })
      return style
    },
    styleImage () {
      const style = Object.assign({}, this.styleSize)
      if (this.loadedUrl !== '') {
        style['background-image'] = `url(${this.loadedUrl})`
      }
      return style
    }
  },
  methods: {
    assignImage () {
      // Add a random delay to avoid seeing all cards fliping at the same time
      setTimeout(
        () => {
          this.loadedUrl = this.image.src
        },
        Math.floor((Math.random() * 2000))
      )
    }
  },
  watch: {
    url (newUrl) {
      this.loadedUrl = ''
      this.image.src = newUrl
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.image.addEventListener('load', this.assignImage)
      this.image.src = this.url
    })
  },
  beforeDestroy () {
    this.image.removeEventListener('load', this.assignImage)
  }
}
</script>

<style scoped>
.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transition: opacity 1s;
}

.card {
  perspective: 1000px;
}

.card.flip .card-flipper {
  transform: rotateY(180deg);
}

.card-flipper {
  transition: 1s;
  transform-style: preserve-3d;
  position: relative;
}

.front, .back {
  backface-visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
}

.front {
  z-index: 2;
  transform: rotateY(0deg);
}

.back {
  transform: rotateY(180deg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// ImageLoader.vue?7a12ecbf